import get from "lodash/get";

export default class LocalStorage {
  constructor(serializer = DefaultSeriazlier) {
    this.serializer = serializer;
  }

  write(key, rawData) {
    localStorage.setItem(key, this.serializer.serialize(rawData));
  }

  read(key) {
    const serializedData = localStorage.getItem(key);

    return serializedData ? this.serializer.deserialize(serializedData) : {};
  }
}

// biome-ignore lint/complexity/noStaticOnlyClass: preexisting, I do agree with the rule though
export class DefaultSeriazlier {
  static serialize(rawData) {
    return JSON.stringify(rawData);
  }

  static deserialize(serializedData) {
    return JSON.parse(serializedData);
  }
}

// biome-ignore lint/complexity/noStaticOnlyClass: preexisting, I do agree with the rule though
export class WorkOrderSearchSerializer {
  static serialize(rawData) {
    return JSON.stringify(rawData);
  }

  static deserialize(serializedData) {
    const deserializedData = JSON.parse(serializedData);

    const scheduledBetween = get(deserializedData, "filters.scheduledBetween", null);
    if (scheduledBetween.startsAt) scheduledBetween.startsAt = new Date(scheduledBetween.startsAt);
    if (scheduledBetween.endsAt) scheduledBetween.endsAt = new Date(scheduledBetween.endsAt);

    const dueBetween = get(deserializedData, "filters.dueBetween", null);
    if (dueBetween.startsAt) dueBetween.startsAt = new Date(dueBetween.startsAt);
    if (dueBetween.endsAt) dueBetween.endsAt = new Date(dueBetween.endsAt);

    const materialAvailabilityBetween = get(deserializedData, "filters.materialAvailabilityBetween", {});
    if (materialAvailabilityBetween.startsAt)
      materialAvailabilityBetween.startsAt = new Date(materialAvailabilityBetween.startsAt);
    if (materialAvailabilityBetween.endsAt)
      materialAvailabilityBetween.endsAt = new Date(materialAvailabilityBetween.endsAt);

    const plannedStartBetween = get(deserializedData, "filters.plannedStartBetween", {});
    if (plannedStartBetween.startsAt) plannedStartBetween.startsAt = new Date(plannedStartBetween.startsAt);
    if (plannedStartBetween.endsAt) plannedStartBetween.endsAt = new Date(plannedStartBetween.endsAt);

    const notes = get(deserializedData, "filters.notes", null);
    if (notes) {
      deserializedData.filters.notes = undefined;
    }

    return deserializedData;
  }
}
